module.exports = __webpack_public_path__ + "static/media/checked.414b68bf.png";